import { render, staticRenderFns } from "./MusicAudio.vue?vue&type=template&id=24662922&scoped=true&"
import script from "./MusicAudio.vue?vue&type=script&lang=js&"
export * from "./MusicAudio.vue?vue&type=script&lang=js&"
import style0 from "./MusicAudio.vue?vue&type=style&index=0&id=24662922&lang=scss&scoped=true&"
import style1 from "./MusicAudio.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24662922",
  null
  
)

export default component.exports